import apiClient from '@/lib/api-client';
import { ApiError } from '@/model/ApiError';
import { Module, Mutation, VuexModule, Action } from 'vuex-module-decorators';
import {
    DeleteTopicRequest,
    PostTopicRequest,
    PutTopicRequest,
    Topic,
} from '@/model/Topic';
import router from '@/router';

@Module({ namespaced: true, preserveState: false })
export default class TopicsStorage extends VuexModule {
    error: ApiError | null = null;

    topics: Topic[] = new Array<Topic>();

    @Mutation
    setError(error: ApiError | null): void {
        this.error = error;
    }

    @Mutation
    setTopics(topics: Topic[]): void {
        this.topics = topics;
    }

    @Action
    fetchTopics(eventId: number): Promise<void | Topic[]> {
        return apiClient
            .get<void, Topic[]>(`/events/${eventId}/topics`)
            .then((data: Topic[]) => {
                this.context.commit('setTopics', data);
                this.context.commit('setError', null);
                return Promise.resolve(data);
            })
            .catch((error) => {
                if (error?.key === 'security.permission.denied') {
                    router.push({ name: 'NotFound' });
                }

                this.context.commit('setTopics', error);
                return Promise.reject();
            });
    }

    @Action
    postTopic(postTopicRequest: PostTopicRequest): Promise<void> {
        return apiClient
            .post<void>(`/events/${postTopicRequest.eventId}/topics`, {
                ...postTopicRequest.topic,
            })
            .then(() => {
                this.context.commit('setError', null);
            })
            .catch((error) => {
                this.context.commit('setError', error);
                return Promise.reject();
            });
    }

    @Action
    putTopic(putTopicRequest: PutTopicRequest): Promise<void> {
        return apiClient
            .put<void>(
                `/events/${putTopicRequest.eventId}/topics/${putTopicRequest.topic.id}`,
                {
                    ...putTopicRequest.topic,
                },
            )
            .then(() => {
                this.context.commit('setError', null);
            })
            .catch((error) => {
                this.context.commit('setError', error);
                return Promise.reject();
            });
    }

    @Action
    deleteTopic(deleteTopicRequest: DeleteTopicRequest): Promise<void> {
        return apiClient
            .delete<void>(
                `/events/${deleteTopicRequest.eventId}/topics/${deleteTopicRequest.topicId}`,
            )
            .then(() => {
                this.context.commit('setError', null);
            })
            .catch((error) => {
                this.context.commit('setError', error);
                return Promise.reject();
            });
    }

    get getError(): ApiError | null {
        return this.error;
    }

    get getTopics(): Array<Topic> {
        return this.topics;
    }
}
